import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { IAiPhotoGenerationStylesPopup } from 'reactApp/ui/AiPhotoGeneration/Modals/Styles/AiPhotoGenerationStylesPopup';

export const renderAiGenerationStylesPopup = (data?: IAiPhotoGenerationStylesPopup) => {
    openPopupHelper({ popupName: popupNames.AI_GENERATION_STYLES, data });
};
